import { Component, OnInit } from '@angular/core';
// Modelos
import { Pendiente } from '../../../models/pendiente';
// Servicios
import { UsuariosPersonalService } from '../../../services/usuarios-personal.service';
import { PushNotificationService } from 'app/services/pushNotification.service';
import { forkJoin } from 'rxjs/observable/forkJoin';


@Component({
    templateUrl: './notificaciones.component.html'
})

export class NotificacionesComponent implements OnInit {
  pendiente: Pendiente = new Pendiente();

  private currentUser: any;

  notificaciones: any[] = [];
  filtro: number = 0; // 0 = Nuevas (vista === 0), 1 = Todas
  bulkLoading = false;


  constructor(
    private usuariosPersonalService: UsuariosPersonalService,
    private pushNotificationService: PushNotificationService,
  ) {}

  ngOnInit() {
    this.currentUser = this.usuariosPersonalService.auth;
    this.obtenerNotificaciones();
  }

  obtenerNotificaciones() {
    this.pushNotificationService
      .obtenerNotificacionesPorAgente(this.currentUser.uid)
      .take(1)
      .subscribe((notificaciones: any[]) => {
        // normaliza por si 'vista' llega como string
        this.notificaciones = (notificaciones || []).map(n => ({
          ...n,
          vista: typeof n.vista === 'string' ? Number(n.vista) : n.vista
        }));
      });
  }

  // Cambia el filtro sin volver a consultar el backend
  cambiarFiltro(filtro: number) {
    this.filtro = filtro;
  }

  // Lista ya filtrada para el *ngFor
  get notificacionesFiltradas(): any[] {
    if (this.filtro === 0) {
      return this.notificaciones.filter(n => Number(n.vista) === 0);
    }
    return this.notificaciones;
  }

  get nuevasCount(): number {
  // counts nuevas across the full list
    return (this.notificaciones || []).filter(n => Number(n.vista) === 0).length;
    }

  marcarComoVista(notificacion: any) {
    if (Number(notificacion.vista) === 0) {
      this.pushNotificationService.marcarComoVista(notificacion.id_notificaciones).subscribe(() => {
        notificacion.vista = 1;
      });
    }
  }

  marcarTodasComoVistas() {
  const nuevas = this.notificacionesFiltradas.filter(n => Number(n.vista) === 0);
  if (!nuevas.length || this.bulkLoading) return;

  this.bulkLoading = true;

  const ids = nuevas.map(n => n.id_notificaciones);

  // optimistic: hide immediately
  this.notificaciones = this.notificaciones.map(n =>
    ids.indexOf(n.id_notificaciones) >= 0 ? { ...n, vista: 1 } : n
  );

  const calls = ids.map(id => this.pushNotificationService.marcarComoVista(id));

  forkJoin(calls).subscribe(
    () => {
      if (this.pushNotificationService.forceRefresh) {
        this.pushNotificationService.forceRefresh();
      }
      this.bulkLoading = false;
    },
    _err => {
      // rollback to 0 on failure
      this.notificaciones = this.notificaciones.map(n =>
        ids.indexOf(n.id_notificaciones) >= 0 ? { ...n, vista: 0 } : n
      );
      this.bulkLoading = false;
    }
  );
}
  trackById = (_: number, item: any) => item.id_notificaciones
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/notificaciones/notificaciones.component.ts